import { SphereItem } from '../sphere_item';
import standardVertexShader from 'shared/renderingEngine/shaders/StandardVertexShader.glsl';
import shapeFragmentShader from 'shared/renderingEngine/shaders/ShapeFragmentShader.glsl';
import { Color, DoubleSide, Group, Mesh, ShaderMaterial, Uniform, Vector2, Vector4 } from 'three';
import { BorderSide } from 'shared/interfaces/planogram';
import { resolvePaletteColor } from 'shared/utils/colors';
// TODO reuse with ShapeObject3D
function isBorderVisible(shapeConfig) {
    return shapeConfig.borderOpacity > 0 && shapeConfig.thickness > 0;
}
function hasCornerRadius(shapeConfig) {
    return shapeConfig.individualCornerRadius.some(it => it > 0);
}
function computeRenderScale(scale, data) {
    const renderScale = scale.clone();
    switch (data.borderSide) {
        case BorderSide.Inside:
            break;
        case BorderSide.Centered:
            renderScale.addScalar(2 * data.thickness);
            break;
        case BorderSide.Outside:
            renderScale.addScalar(4 * data.thickness);
            break;
    }
    return renderScale;
}
function prepareColor(color, opacity, palette) {
    const colorHex = resolvePaletteColor(color, palette);
    const parsedColor = new Color(colorHex);
    return new Vector4(...parsedColor.toArray(), opacity);
}
export class RectangleComponent extends SphereItem {
    constructor(itemData, planogram) {
        const scale = new Vector2(itemData.width, itemData.height);
        const renderScale = computeRenderScale(scale, itemData.data);
        itemData.width = renderScale.width;
        itemData.height = renderScale.height;
        const offset = renderScale.sub(scale).multiplyScalar(0.5);
        itemData.x -= offset.x;
        itemData.y -= offset.y;
        super(itemData, planogram);
    }
    createMesh() {
        this.geometry = this.generateGeometry();
        this.material = this.createMaterial();
        const mesh = new Mesh(this.geometry, this.material);
        mesh.renderOrder = this.renderOrder;
        mesh.userData = {
            component: this
        };
        this.object3D = new Group();
        this.object3D.renderOrder = this.renderOrder;
        this.object3D.add(mesh);
        if (this.hasInput()) {
            mesh.layers.enable(2);
            this.object3D.layers.enable(2);
        }
        return Promise.resolve();
    }
    configToUniforms(shapeConfig) {
        return {
            opacity: new Uniform(1),
            borderSize: new Uniform(shapeConfig.thickness * 2), // the previous implementation rendered the border at twice the size listed in the UI
            borderColor: new Uniform(prepareColor(shapeConfig.borderColor, shapeConfig.borderOpacity, this.planogram.palette)),
            fillColor: new Uniform(prepareColor(shapeConfig.fillColor, shapeConfig.fillOpacity, this.planogram.palette)),
            scale: new Uniform(new Vector2(this.width, this.height)),
            cornerRadius: new Uniform(new Vector4(...shapeConfig.individualCornerRadius))
        };
    }
    createMaterial() {
        const defines = {};
        if (isBorderVisible(this.data))
            defines.BORDER = '';
        if (hasCornerRadius(this.data))
            defines.CORNER_RADIUS = '';
        const uniforms = this.configToUniforms(this.data);
        return new ShaderMaterial({
            vertexShader: standardVertexShader,
            fragmentShader: shapeFragmentShader,
            depthTest: false,
            uniforms,
            defines,
            transparent: true,
            side: DoubleSide
        });
    }
}
